/*eslint-disable*/
import api from './'

class CourseApi {

    // GET: course/:id
    static show(id) {
        return api.axios.get('/course/' + id)
            .then(response => response.data.course)
    }

    //PUT: course/:id
    static update(id, course) {
        return api.axios.put('/course/' + id, course)
            .then(response => response.data.course)
    }

    // POST: course
    static create(course) {
        return api.axios.post('/course', course)
            .then(response => response.data.course);
    }

    // GET: course
    static list(params, cancelToken = null) {
        return api.axios.get('/course', {params, cancelToken})
            .then(response => response.data)
    }

    static delete(id) {
        return api.axios.delete('/course/' + id)
            .then(response => response.data)
    }

    static exportList(params) {
        return api.axios.get('/course/export', {params})
            .then(response => response.data)
    }

    static getCourseName(id) {
        return api.axios.get('/course/get-name/' + id)
            .then(response => response.data)
    }

    static getCoursesForTariff() {
        return api.axios.get('course/for-tariff')
            .then(response => response.data)
    }
}

export default CourseApi;
